import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { loadCalendlyScript } from './utils/calendly';
// Lazy load legal pages (not critical for initial load)
const ImpressumPage = lazy(() => import('./pages/ImpressumPage').then(module => ({
  default: module.ImpressumPage
})));
const DatenschutzPage = lazy(() => import('./pages/DatenschutzPage').then(module => ({
  default: module.DatenschutzPage
})));
// Loading fallback component
function PageLoader() {
  return <div className="min-h-screen flex items-center justify-center bg-[#0A0E27]" data-id="element-0" data-mp="2wifgpfyzpczr">
      <div className="text-white text-lg" data-id="element-1" data-mp="28te4dhn1dhp7">Lädt...</div>
    </div>;
}
export function App() {
  // Load Calendly script on mount
  useEffect(() => {
    loadCalendlyScript();
  }, []);
  return <HelmetProvider data-id="element-2" data-mp="3iiweonbohg2p">
      <BrowserRouter data-id="element-3" data-mp="3ijfu9xduvsdk">
        <ScrollToTop data-id="element-4" data-mp="3ii4t85bsoyq5" />
        <Layout data-id="element-5" data-mp="3mlaxx8j9ehui">
          <Suspense fallback={<PageLoader data-id="element-7" data-mp="3mk868ye44bdj" />} data-id="element-6" data-mp="3mkrefndynled">
            <Routes data-id="element-8" data-mp="3mjgannkimdn9">
              <Route path="/" element={<HomePage data-id="element-10" data-mp="3rbzn2h7gv2qh" />} data-id="element-9" data-mp="3rc9dg5wfbbwp" />
              <Route path="/impressum" element={<ImpressumPage data-id="element-12" data-mp="3relv0hy9rk98" />} data-id="element-11" data-mp="3rcsy3udgkeef" />
              <Route path="/datenschutz" element={<DatenschutzPage data-id="element-14" data-mp="5ggxfcks0yi" />} data-id="element-13" data-mp="67znpl2q47d" />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>;
}